import { render, staticRenderFns } from "./CustomerDetailsPaymentHistory.vue?vue&type=template&id=f1d3340c&scoped=true"
import script from "./CustomerDetailsPaymentHistory.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailsPaymentHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d3340c",
  null
  
)

export default component.exports